export const FETCH_WORKSPACE_TEAMS = 'fetchWorkspaceTeams';
export const FETCH_PUBLIC_WORKSPACE_TEAMS = 'fetchPublicWorkspaceTeams';
export const FETCH_USER_TEAMS = 'fetchUserTeams';
export const FETCH_PUBLIC_USER_TEAMS = 'fetchPublicUserTeams';
export const FETCH_TEAMS_BY_IDS = 'fetchTeams';
export const CREATE_TEAM = 'createTeam';
export const UPDATE_TEAM = 'updateTeam';
